import * as proj4 from "proj4";

export const getProj4 = () => {
  return (proj4 as any).default || proj4;
};
